module.exports = __webpack_public_path__ + "5887ba4166d3fa4ee7359091b004c55e.jpg";